// material-ui

import tablecolumnicon from '../../../assets/images/table-column.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const TableColumnIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={tablecolumnicon} alt="View Row" width="22"  />
    );
};

export default TableColumnIcon;
